import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output
} from '@angular/core';
import { FuelType } from 'src/app/interfaces/vehicle';
import { WorkVehicleWarehouse } from '../../../../core/services/vehicles.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteDriverUpdateModalComponent } from '../route-driver-update-modal/route-driver-update-modal.component';
import { PERMISSIONS, PermissionService } from 'src/app/core/services/permission.service';


@Component({
  selector: '[app-route-history-table-row]',
  templateUrl: './route-history-table-row.component.html',
  styleUrls: ['./route-history-table-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouteHistoryTableRowComponent {
  @Input() isOpen = false;
  @Input() data: WorkVehicleWarehouse;

  @HostBinding('class.sum-row')
  @Input() aggregationRow = false;
  @Output() rollover = new EventEmitter();
  @HostBinding('class.is-selected')
  @Input() isSelected = false;
  @Input() isDriver = false;
  @Input() fuelDimmension = 'DISTANCE';
  @Input() vehicleFuelType: FuelType;

  constructor(private modal: NgbModal, public permissionService: PermissionService) {
  }

  get startLocalization() {
    return this.data.RIDE_START_POI
      ? this.data.RIDE_START_POI[0].v.name
      : this.data.RIDE_START_REVGEO
        ? this.data.RIDE_START_REVGEO[0].v : '-';
  }

  get endLocalization() {
    return this.data.PARK_POI
      ? this.data.PARK_POI[0].v.name
      : this.data.PARK_REVGEO
        ? this.data.PARK_REVGEO[0].v : '-';
  }

  get odometerRangeLabel() {
    if (!this.data || !this.data.RIDE_STARTTOTALDISTANCE || !this.data.PARK_STARTTOTALDISTANCE) {
      return '';
    }
    const startOdo: string = this.data.RIDE_STARTTOTALDISTANCE[0].v ?
      `${this.formatDistance(this.data.RIDE_STARTTOTALDISTANCE[0].v)} km` :
      '...';
    const endtOdo: string = this.data.PARK_STARTTOTALDISTANCE[0].v ?
      `${this.formatDistance(this.data.PARK_STARTTOTALDISTANCE[0].v)} km` :
      '...';
    return `${startOdo} - ${endtOdo}`;
  }

  formatDistance(distance: number): string {
    return distance ?
      distance.toLocaleString('fr-FR', { minimumFractionDigits: 0 }) :
      '0';
  }

  handlerRolloverToggle($event) {
    $event.stopPropagation();
    if (!this.aggregationRow) {
      this.rollover.emit();
    }
  }

  showUpdateDriverModal($event: MouseEvent) {
    $event.stopPropagation();
    if (this.aggregationRow) {
      return;
    }
    if (!this.permissionService.hasPermission(PERMISSIONS.VEHICLE_UPDATE)) {
      return;
    }
    console.log('this.Data', this.data);
    const vehicleId: string = this.data.VEHICLE[0].v.id;
    const rideStartDate: string = this.data.RIDE_STARTDATE[0].v;
    const parkStartDate: string = this.data.PARK_STARTDATE[0].v;
    const parkEndDate: string = this.data.PARK_ENDDATE[0].v;
    const driverId: string = this.data.DRIVER[0].v ? this.data.DRIVER[0].v.id : null;
    const modal = this.modal.open(RouteDriverUpdateModalComponent);
    modal.componentInstance.vehicleId = vehicleId;
    modal.componentInstance.rideStartEventDate = rideStartDate;
    modal.componentInstance.parkStartEventDate = parkStartDate;
    modal.componentInstance.parkEndEventDate = parkEndDate;
    modal.componentInstance.driverId = driverId;
    modal.result.then(res => {}, () => {});
  }

}
